import { IframeContent } from 'types/other';
import { PaginationParams } from 'types';

import { api } from './setupApi';

interface EditIframeContent {
  seoTitle: string;
  seoDesc: string;
}

interface NewIframeContent extends EditIframeContent {
  signedId: string;
  h1Tag: string;
}

interface IframeContentsResponse {
  count: number;
  iframeContents: IframeContent[];
}

interface IframeContentsRequest extends PaginationParams {
  content_type?: string;
}

class IframeContentsModel {
  prefix = '/iframe_contents';

  getIframeContents = (params: IframeContentsRequest) =>
    api.get<IframeContentsResponse>(`${this.prefix}`, { params }).then(r => r.data);

  createIframeContent = (data: NewIframeContent) => api.post(`${this.prefix}`, data);

  updateIframeContent = (id: number, data: EditIframeContent) => api.put(`${this.prefix}/${id}`, data);

  deleteIframeContent = (id: number) => api.delete(`${this.prefix}/${id}`);
}

export const iframeContentsModel = new IframeContentsModel();
